export default class Menu {
  constructor() {
    this.this = '#main-menu'
    this.$this = $(this.this)
    this.$mainMenu = $('#main-menu').find('.main-menu__ul')
    this.elementItem = '.js-hamburger, html, #main-menu, #header'
    this.$header = $('#header, #main-menu-mobile')
    this.$hamburgerMenu = $('.js-hamburger')
    this.li = this.$this.find('.main-menu__ul >li>a')
    this.liLevel1 = this.$this.find('.main-menu__ul .li-menu-item-0')
    this.liLevel2 = this.$this.find('.main-menu__ul .menu-depth-1')
    this.isOpenMenu = 'is-open-menu'
    this.isOpenMenuChild = 'open-menu-child'
    this.isOpenChild = 'is-open-child'
    this.$linksInMenu = $('.header a:not(.skip-link), .header button')
    this.$firstLinkInMenu = this.$linksInMenu.first()
    this.$lastLinkInMenu = this.$linksInMenu.last()
    this.$skipLink = $('.header a.skip-link')
    this.ariaExpanded = 'aria-expanded'
    this.hoverTimeout = null
    this.hoverDelay = 200
    this.clsHoveringSub = 'is-hovering-sub'
    this.clsHovering = 'is-hovering'
  }

  init() {
    if (this.$this.length) {
      this.openMainMenu()
      this.clickOutSite()
      this.toggleTabIndexSkipLink()
      this.clickArrowOpenDropdownMenuLevel1()
      this.clickLiOpenDropdownMenuLevel1()
      this.clickArrowOpenDropdownMenuLevel2()
      this.clickLiOpenDropdownMenuLevel2()
      this.handleDesktopHover()
      // Mega menu sections are always expanded - no toggle needed
    }
  }

  openMainMenu() {
    this.$header.on('click', '.js-hamburger', (e) => {
      const ele = e.currentTarget

      if ($(ele).hasClass(this.isOpenMenu)) {
        $(this.elementItem).removeClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Open menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, false)
        this.$skipLink.removeAttr('tabindex')
      } else {
        $(this.elementItem).addClass(this.isOpenMenu)
        this.$hamburgerMenu.find('.sr-only').text('Close menu')
        this.$hamburgerMenu.attr(this.ariaExpanded, true)
        this.bindEventFocusOnMenu()
      }
    })
  }

    /* micro function */
  microOpenCloseLevel1(currentElement, openClass, isLiLv1 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parents('.li-menu-item-0')
    if ($(window).width() < 1199) {
      if (eleParent.find('.sub-menu').length && !eleParent.hasClass(openClass)) {
        this.liLevel1.removeClass(openClass)
        this.liLevel1.find('> .menu-item-link').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv1) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }
    return true
  }
    /* end micro */

  toggleTabIndexSkipLink() {
    $(window).on('resize', () => {
      if ($(window).outerWidth() < 992) {
        this.$skipLink.removeAttr('tabindex')
      }
    })
  }

  clickArrowOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', '.sub-menu-item-0 .arrows-menu', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.microOpenCloseLevel1(e, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel1() {
    this.liLevel1.on('click', 'div.sub-menu-item-0', (e) => {
      if ($(window).width() < 1200) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.microOpenCloseLevel1(e, this.isOpenChild, true)
    })
  }

  /* micro function for level 2 */
  microOpenCloseLevel2(currentElement, openClass, isLiLv2 = false) {
    const ele = currentElement.currentTarget
    const eleParent = $(ele).parents('.menu-depth-1')
    if ($(window).width() < 1199) {
      if (eleParent.find('.sub-menu').length && !eleParent.hasClass(openClass)) {
        this.liLevel2.removeClass(openClass)
        this.liLevel2.find('> .menu-item-link').each((_i, el) => {
          if ($(el).attr(this.ariaExpanded)) {
            $(el).attr(this.ariaExpanded, false)
          }
        })
        eleParent.addClass(openClass)
        $(ele).attr(this.ariaExpanded, true)
        if (isLiLv2) {
          return false
        }
      } else {
        eleParent.removeClass(openClass)
        $(ele).attr(this.ariaExpanded, false)
      }
    }
    return true
  }
  /* end micro for level 2 */

  clickArrowOpenDropdownMenuLevel2() {
    this.liLevel2.on('click', '.sub-menu-item-1 .arrows-menu', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.microOpenCloseLevel2(e, this.isOpenChild)
    })
  }

  clickLiOpenDropdownMenuLevel2() {
    this.liLevel2.on('click', 'div.sub-menu-item-1', (e) => {
      if ($(window).width() < 1200) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.microOpenCloseLevel2(e, this.isOpenChild, true)
    })
  }

  bindEventFocusOnMenu() {
    this.$skipLink.attr('tabindex', -1)
    this.$firstLinkInMenu.get(0).addEventListener('keydown', this.shiftTabFocusToLast.bind(this))
    this.$lastLinkInMenu.get(0).addEventListener('keydown', this.tabFocusToFirst.bind(this))
  }

  tabFocusToFirst(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && !e.shiftKey) {
      e.preventDefault()
      this.$firstLinkInMenu.focus()
    }
  }

  shiftTabFocusToLast(e) {
    if (e.which === 9 && $(window).outerWidth() < 992 && e.shiftKey) {
      e.preventDefault()
      this.$lastLinkInMenu.focus()
    }
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest('#header.is-open-menu').length) {
        $(this.elementItem).removeClass(this.isOpenMenu)
      }
    })
  }

  closeAllSubmenu() {
    const $liHover = this.$this.find(`.main-menu__ul>li.${this.clsHovering}`)
    $liHover.removeClass(this.clsHovering)
    if ($liHover.hasClass('has-sub')) {
      $liHover.find('> a').attr(this.ariaExpanded, false)
    }
  }

  handleDesktopHover() {
    if ($(window).width() >= 1200) {
      const $menuItems = this.$mainMenu.find('> li')
      let switchTimeout = null

      $menuItems.each((_index, item) => {
        const $item = $(item)
        let itemTimeout = null

        $item.on('mouseenter', () => {
          const hasActiveItem = $menuItems.filter(`.${this.clsHovering}`).length > 0
          $menuItems.each((_i, otherItem) => {
            const $otherItem = $(otherItem)
            const otherTimeout = $otherItem.data('hoverTimeout')
            if (otherTimeout) {
              clearTimeout(otherTimeout)
            }
          })

          if (itemTimeout) {
            clearTimeout(itemTimeout)
            itemTimeout = null
          }

          if (switchTimeout) {
            clearTimeout(switchTimeout)
          }

          if (hasActiveItem) {
            switchTimeout = setTimeout(() => {
              $menuItems.not($item).removeClass(this.clsHovering).find(`.${this.clsHoveringSub}`).removeClass(this.clsHoveringSub)
              $item.addClass(this.clsHovering)
            }, this.hoverDelay)
          } else {
            $item.addClass(this.clsHovering)
          }
        })

        $item.on('mouseleave', () => {
          if (switchTimeout) {
            clearTimeout(switchTimeout)
            switchTimeout = null
          }

          itemTimeout = setTimeout(() => {
            $item.removeClass(this.clsHovering)
            $item.find(`.${this.clsHoveringSub}`).removeClass(this.clsHoveringSub)
          }, this.hoverDelay)
          $item.data('hoverTimeout', itemTimeout)
        })
      })

      const $subMenuItems = $menuItems.find('>.sub-menu > li')
      $subMenuItems.each((_index, item) => {
        const $item = $(item)
        let subItemTimeout = null
        let subSwitchTimeout = null

        $item.on('mouseenter', () => {
          const hasActiveSibling = $item.siblings(`.${this.clsHoveringSub}`).length > 0
          $item.siblings().each((_i, sibling) => {
            const $sibling = $(sibling)
            const siblingTimeout = $sibling.data('subHoverTimeout')
            if (siblingTimeout) {
              clearTimeout(siblingTimeout)
            }
          })

          if (subItemTimeout) {
            clearTimeout(subItemTimeout)
            subItemTimeout = null
          }

          if (subSwitchTimeout) {
            clearTimeout(subSwitchTimeout)
          }

          if (hasActiveSibling) {
            subSwitchTimeout = setTimeout(() => {
              $item.siblings().removeClass(this.clsHoveringSub)
              $item.addClass(this.clsHoveringSub)
            }, this.hoverDelay)
          } else {
            $item.addClass(this.clsHoveringSub)
          }
        })

        $item.on('mouseleave', () => {
          if (subSwitchTimeout) {
            clearTimeout(subSwitchTimeout)
            subSwitchTimeout = null
          }

          subItemTimeout = setTimeout(() => {
            $item.removeClass(this.clsHoveringSub)
          }, this.hoverDelay)
          $item.data('subHoverTimeout', subItemTimeout)
        })
      })
    }

    $(window).on('resize', () => {
      if ($(window).width() >= 1200) {
        const $menuItems = this.$mainMenu.find('> li')
        const $subMenuItems = this.$mainMenu.find('.sub-menu li')
        $menuItems.off('mouseenter mouseleave')
        $subMenuItems.off('mouseenter mouseleave')
        this.handleDesktopHover()
      }
    })
  }

  // Mega menu sections toggle removed - all sections now always expanded

}

new Menu().init()
